import { List } from 'immutable'
import { MESSAGE_SENDER } from 'widget/constants'

import {
  createNewMessage,
  createCarousel,
  createComponentMessage,
} from './helper'
import * as actionTypes from '../actions/actionTypes'

const initialState = List([])

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.ADD_NEW_USER_MESSAGE: {
      return state.push(createNewMessage(action.text, MESSAGE_SENDER.USER, action.timestamp))
    }
    case actionTypes.ADD_NEW_RESPONSE_MESSAGE: {
      return state.push(createNewMessage(action.text, MESSAGE_SENDER.BOT, action.timestamp, action.isLiveAgent))
    }
    case actionTypes.ADD_CAROUSEL: {
      return state.push(createCarousel(action.carousel))
    }
    case actionTypes.ADD_COMPONENT_MESSAGE: {
      return state.push(createComponentMessage(action.component, action.props, action.showAvatar))
    }
    case actionTypes.DROP_MESSAGES: {
      return List([])
    }
    case actionTypes.RESET_CHAT:
      return initialState
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/ChatWidget/store/reducers/messagesReducer.js